interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}>
      <span className="inline-flex items-center gap-2 font-label text-sm text-primary-700">
        <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
        {eyebrow}
      </span>
      <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 text-balance">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}